import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/** Lý do chặn sau khi mật khẩu đã đúng (đặc tả §5). */
export type AuthDenyReason = 'NOT_ADMIN' | 'ROLE_CHECK_FAILED';

export interface AuthError {
  /** HTTP status từ NestJS (`statusCode`). Không có khi mất mạng. */
  statusCode?: number;
  code?: number;
  /** `message` gốc của backend (có thể là mảng khi DTO bị từ chối). */
  message?: string | string[];
  path?: string;
  timestamp?: string;
  networkError?: boolean;
  reason?: AuthDenyReason;
}

/** `login`: đang gọi auth/login. `checking`: mật khẩu đúng, đang gọi auth/status để xem vai trò. */
export type AuthPhase = 'idle' | 'login' | 'checking';

interface InitialState {
  data: any;
  isLoading: boolean;
  phase: AuthPhase;
  error: AuthError;
  isTokenExpired?: boolean;
}
const initialState: InitialState = {
  data: null,
  isLoading: false,
  phase: 'idle',
  error: {},
  isTokenExpired: false,
};

const sessionSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    getAuthLoading: (state) => {
      state.isLoading = true;
      state.phase = 'login';
      state.error = {};
    },
    setAuthPhase: (state, action: PayloadAction<AuthPhase>) => {
      state.phase = action.payload;
      state.isLoading = action.payload !== 'idle';
    },
    getAuthSuccess: (state, action?) => {
      state.data = action?.payload;
      state.isLoading = false;
      state.phase = 'idle';
      state.error = {};
    },
    getAuthFailure: (state, action: PayloadAction<AuthError | undefined>) => {
      state.isLoading = false;
      state.phase = 'idle';
      state.error = action.payload || {};
    },
    removeAuth: (state) => {
      state.isLoading = false;
      state.phase = 'idle';
      state.error = {};
    },
    changeTokenExpired: (state) => {
      state.data = null;
      state.error = {};
      state.isLoading = false;
      state.phase = 'idle';
      state.isTokenExpired = true;
    },
  },
});

export const {
  getAuthLoading,
  setAuthPhase,
  getAuthSuccess,
  getAuthFailure,
  removeAuth,
  changeTokenExpired,
} = sessionSlice.actions;

export default sessionSlice.reducer;
